import React from 'react';
import { BigIcon, CenteredContainer, Description, Title, Wrapper } from '../StatusViews.styles';

export const Pending = () => {
  return (
    <Wrapper>
      <CenteredContainer>
        <BigIcon className="far fa-history" />
        <Title fontSize="h4" color="neutral">
          New Account Application Pending
        </Title>
        <Description>
          We&apos;re reviewing your application and will notify you with next steps.
        </Description>
      </CenteredContainer>
    </Wrapper>
  );
};
